import styled from 'styled-components';

const StyledSelect = styled('select')`
  width: 150px;
`;
export { StyledSelect };
